import { EndUserLicenseAgreementStatus } from '../constants';
import { FormArray, UntypedFormBuilder, Validators } from '@angular/forms';
import { Language, ListQueryParam } from '../../../../../common/constants';
import { ControlStringProperty, ListRange, SearchCriteriaBase } from '../../../../../common/models';

export class EndUserLicenseAgreementItem {
  id?: number = null;
  eulaStatus: EndUserLicenseAgreementStatus = null;
  eulas: EndUserLicenseAgreement[] = [];
  eulaVersion: number = null;

  constructor(params?: EndUserLicenseAgreementItem) {
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class EndUserLicenseAgreement {
  data?: string = null;
  documentId?: string = null;
  languageCode: Language = null;

  constructor(params?: EndUserLicenseAgreement) {
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class EulaItemForm {
  id?: number;

  constructor(
    eulaItemModel: EndUserLicenseAgreementItem,
    fb: UntypedFormBuilder,
    public eulas: FormArray = fb.array([]),
  ) {
    if (eulaItemModel.id) {
      this.id = eulaItemModel.id;
    }
  }
}

export class EulaItemFileForm {
  documentId?: string;

  constructor(
    eulaItemFileModel: EndUserLicenseAgreement,
    public languageCode: ControlStringProperty = [eulaItemFileModel.languageCode, [Validators.required]],
    public data: [string, Validators | Validators[]] = [
      eulaItemFileModel.data || null,
      eulaItemFileModel.documentId ? [] : [Validators.required],
    ],
  ) {
    this.documentId = eulaItemFileModel.documentId || null;
  }
}

export class EulaListSearchCriteria extends SearchCriteriaBase {
  [ListQueryParam.Filter]: string;
  [ListQueryParam.Status]: string;
  // TODO change after sorting implementation
  [ListQueryParam.Sort] = 'eulaVersion:desc';

  constructor(params?: Partial<EulaListSearchCriteria> | ListRange) {
    super();
    if (params) {
      Object.assign(this, params);
    }
  }
}
